import styled, { css } from 'styled-components'

export const PaginationIcon = styled.div`
    width: 1rem;
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
        fill: currentColor;
        path {
            fill: currentColor;
        }
    }
`

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
`

export const PaginationDots = styled.span(
    ({ theme }) => css`
        padding: 0 ${theme.spacing.xxSmall};
        display: inline-flex;
        align-items: center;
        justify-content: center;
    `,
)

export const PageButton = styled.button<{ active?: boolean }>(
    ({ theme, active }) => css`
        padding: 0.375rem ${theme.spacing.xSmall};
        border-radius: ${theme.typography.border.radius.small};
        border: 1px solid ${active ? theme.colors.black : theme.colors.tfwBlack38};
        background-color: ${active ? theme.colors.black : theme.colors.white};
        color: ${active ? theme.colors.white : theme.colors.black};
        cursor: pointer;
        min-width: 2.25rem;
        transition: 0.2s ease;

        &:hover {
            border-color: ${theme.colors.black};
        }
        &:disabled {
            cursor: not-allowed;
            opacity: 0.4;
            background-color: ${theme.colors.tfwBlack3};
            border-color: ${theme.colors.tfwBlack38};
            color: ${theme.colors.tfwBlack38};
            pointer-events: none;

            svg {
                fill: ${theme.colors.tfwBlack45};
                opacity: 0.5;
            }
        }
    `,
)
